import React from 'react'
import { Component } from 'react'


class BriefStatsLoading extends Component {

    render() {
        return (
            <div className="brief-stats placeholder-content" style={{padding: '1rem'}}>
                <h4 className="placeholder-content-item">.............................................</h4>
                <div className="list">
                    <div>
                        <b className="placeholder-content-item">......................</b>
                        <ul>
                            <li className="placeholder-content-item">....................</li>
                            <li className="placeholder-content-item">.......................</li>
                            <li className="placeholder-content-item">....................</li>
                            <li className="placeholder-content-item">......................</li>

                        </ul>
                    </div>
                    <div>
                        <b className="placeholder-content-item">...............................</b>
                        <ul>
                            <li className="placeholder-content-item">...................</li>
                            <li className="placeholder-content-item">...........................</li>
                            <li className="placeholder-content-item">......................</li>
                            <li className="placeholder-content-item">...................</li>
                            <li className="placeholder-content-item">........................</li>
                            <li className="placeholder-content-item">...................</li>

                        </ul>
                    </div>
                    <div>
                        <b className="placeholder-content-item">...........................................</b>
                        <ul>
                            <li className="placeholder-content-item">...................</li>
                            <li className="placeholder-content-item">.........................</li>
                            <li className="placeholder-content-item">...................</li>
                            <li className="placeholder-content-item">..........................</li>

                        </ul>
                    </div>
                    <div>
                        <b className="placeholder-content-item">.....................................</b>
                        <ul>
                            <li className="placeholder-content-item">........................</li>
                            <li className="placeholder-content-item">...................</li>

                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default BriefStatsLoading;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/loading/BriefStatsLoading.js